export default "__VITE_ASSET___do$MLGj__"